<template>
  <container title='成交溢价率分布' :loading='loading' :nodata='nodata' style='padding-bottom: 0;height: 266px;'>
    <div id='premiumRateDistribution' style='height: 225px;'>

    </div>
  </container>
</template>

<script>
  import container from "../container";
  import {dealPremiumRateStatistics} from "../../../../../api/bigData";

  export default {
    name: "premiumRateDistribution",
    components: {
      container,
    },
    data() {
      return {
        myChart: null,
        initData: [],
        loading:false,
        nodata:false,
      }
    },
    methods: {
      initEcharts() {
        var echarts = require('echarts');
        var myChart = echarts.init(document.getElementById('premiumRateDistribution'));
        this.myChart = myChart
        let option = option = {

          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          dataZoom: [
            {
              type: 'slider',
              xAxisIndex: [0],
              show: this.initData.length<=5 ? false : true,
              startValue:1,
              endValue:5,
              borderColor: 'rgba(255,255,255,0)',
              backgroundColor:"rgba(255,255,255,0)",
              dataBackground:{
                lineStyle:{
                  color:'rgba(255,255,255,0)',
                  width:'0',
                },
                areaStyle:{
                  color:'rgba(255,255,255,0)',
                },
              },
              handleSize:"0",
              textStyle:{
                color:"rgba(255,255,255,0)"
              },
              bottom:"-23",
            },
            {
              type: 'inside',
              zoomOnMouseWheel:false,
              moveOnMouseWheel:true,
              show: this.initData.length<=5 ? false : true,
              xAxisIndex: [0],
              start: 1,
              end: this.initData.length<=5 ? 100 : 40
            },
          ],

          grid: {
            top:20,
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              axisLine: {
                lineStyle: {
                  color: "#529DFF",
                },
              },
              splitArea: {
                show: false
              },
              nameGap: 8,
              splitNumber: 8,
              axisTick: {
                show: false
              },
              axisLabel: {
                formatter : function(params){
                  var newParamsName = "";// 最终拼接成的字符串
                  var paramsNameNumber = params.length;// 实际标签的个数
                  var provideNumber = 3;// 每行能显示的字的个数
                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
                  /**
                   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
                   */
                  // 条件等同于rowNumber>1
                  if (paramsNameNumber > provideNumber) {
                    /** 循环每一行,p表示行 */
                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = "";// 表示每一次截取的字符串
                      var start = p * provideNumber;// 开始截取的位置
                      var end = start + provideNumber;// 结束截取的位置
                      // 此处特殊处理最后一行的索引值
                      if (p == rowNumber - 1) {
                        // 最后一次不换行
                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        // 每一次拼接字符串并换行
                        tempStr = params.substring(start, end) + "\n";
                      }
                      newParamsName += tempStr;// 最终拼成的字符串
                    }

                  } else {
                    // 将旧标签的值赋给新标签
                    newParamsName = params;
                  }
                  //将最终的字符串返回
                  if(newParamsName.length>5){
                    return newParamsName.substr(0,5)+'...'
                  }else{
                    return newParamsName
                  }
                }
              },
              type: 'category',
              boundaryGap: false,
              data: this.initData.map((item) => {
                return item.name
              })
            }
          ],
          yAxis: [
            {
              splitLine: {
                show: true,
                lineStyle: {
                  type: 'dashed',
                  color: '#529DFF'
                }
              },
              axisLine: {
                lineStyle: {
                  color: "#529DFF",
                },
              },
            }
          ],
          series: [
            {
              type: 'line',
              stack: '总量',
              symbolSize:8,
              smooth: true,
              lineStyle: {
                color: '#9C80F7',
              },
              itemStyle: {
                color: "#9013FE",

              },
              areaStyle: {
                color:'rgba(156,128,247,.3)',
              },
              data: this.initData.map((item) => {
                return item.rate
              })
            }
          ]
        };

        this.myChart.setOption(option)
        this.myChart.on('click', (params) => {
          let dataIndex=params.dataIndex
          let query = {companyId: this.initData[dataIndex].id,companyName:this.initData[dataIndex].name}
          this.$router.push({path: '/premiumAnalysis' ,query:query})
        })
      },
      init(){
        this.loading=true
        dealPremiumRateStatistics({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.initData=data.content.list
            this.loading=false
            this.$nextTick(function () {
              this.initEcharts()
            })
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
          this.nodata=!this.initData.length
        })

      },
    },
    created() {
      this.init()
    },
  }
</script>

<style scoped lang="scss">
  .premiumRateDistribution {

  }
</style>
